export function formatPlayerRowLabel(row, { roster = [], hostId, localPlayerId }) {
  const playerId = row.playerId
  const rosterRow = roster.find(p => String(p.id) === String(playerId))
  const name = row.name ?? rosterRow?.name ?? playerId
  const hostStar = hostId != null && String(playerId) === String(hostId) ? ' *' : ''
  const you = localPlayerId != null && String(playerId) === String(localPlayerId) ? ' (you)' : ''
  return `${name}${hostStar}${you}`
}

export function deathmatchCountdownTotalSec(remainingMs) {
  if (remainingMs == null || !Number.isFinite(remainingMs)) return null
  return Math.ceil(Math.max(0, remainingMs) / 1000)
}

export function formatDeathmatchCountdown(remainingMs) {
  const totalSec = deathmatchCountdownTotalSec(remainingMs)
  if (totalSec == null) return ''
  const m = Math.floor(totalSec / 60)
  const s = totalSec % 60
  return `${m}:${String(s).padStart(2, '0')}`
}

export function formatTeamScore(teamScores) {
  if (!teamScores) return ''
  return `Yellow ${teamScores.yellow ?? 0} - Cyan ${teamScores.cyan ?? 0}`
}

export function renderPlayers(players, localPlayerId) {
  return players.map(player => `
    <li class="hud-player-row">
      <span class="chip">
        <span class="dot" style="background-color: ${player.color}"></span>
        ${player.name}${player.id === localPlayerId ? ' (you)' : ''}
        ${player.teamName ? `<span class="team-tag" data-team="${player.teamId}">${player.teamName}</span>` : ''}
      </span>
    </li>
  `).join('')
}

export function renderHUD(players, localPlayerId, mode = 'coop') {
  const showLivesOrTeamRow = mode !== 'deathmatch'
  return `
    <div class="hud" data-hud-mode="${mode}">
      <div class="hud-stats">
        <span data-role="hud-score">Score: 0</span>
        ${showLivesOrTeamRow ? '<span data-role="hud-lives">Lives: 3</span>' : ''}
        <span data-role="hud-shields" hidden>
          <span class="hud-shields-label">Shields</span>
          <span class="hud-shields-bar"><span class="hud-shields-fill" style="--p: 1"></span></span>
          <span class="hud-shields-count">0/0</span>
        </span>
        <span data-role="hud-timer"></span>
      </div>
      <ul class="hud-players">${renderPlayers(players, localPlayerId)}</ul>
      <ul class="hud-feed"></ul>
      <div class="hud-controls">
        [W][A][S][D] or arrows to MOVE - [SPACE] to SHOOT
      </div>
    </div>
  `
}
